/* eslint-disable @typescript-eslint/no-unused-vars */
import { Handle, Position } from '@xyflow/react'
import genericLogo from '@/assets/drilling.png'

function DrillingNode({ data, isConnectable }) {
  return (
    <div className="custom-node-generic robots-limits">
      <div className="grid grid-cols-1">
        <div>
          <div className="text-center">
            <img src={genericLogo} alt="Logo" className="custom-node-robots-logo" />
          </div>
          <div className="text-center">
            <b>Drilling</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default DrillingNode
